import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ArrowOutwardIcon } from 'icons/materialIcons'; // Import the icon

const SupportArticlesItem = ({ title, description, children, articleId }) => {
  const navigate = useNavigate();

  const handleViewArticle = () => {
    navigate(`/blog/${articleId}`);
  };

  return (
    <Box
      sx={{
        backgroundColor: 'background.paper',
        borderRadius: '16px',
        padding: 2,
        border: '1px solid #f2f2f2',
        boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.05)',
        margin: 0,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'space-between',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: { xs: 'column', sm: 'row' },
        }}
      >
        <Box
          sx={{
            width: '50px',
            height: '50px',
            borderRadius: '12px',
            border: '1px solid #f2f2f2',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: "#828282",
            marginRight: { sm: 2, xs: 0 },
            marginBottom: { xs: 1, sm: 0 },
          }}
        >
          {children}
        </Box>

        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 500, fontSize: '0.9rem' }}>{title}</Typography>
          <Typography variant="body2" sx={{ color: '#828282', fontSize: '0.9rem', marginBottom: 3 }}>{description}</Typography>
        </Box>
      </Box>

      <IconButton
        onClick={handleViewArticle}
        sx={{
          marginTop: 'auto',
          color: '#828282',
          fontWeight: 500,
          fontSize: '0.9rem',
          textTransform: 'none',
          borderColor: '#f2f2f2',
          '&:hover': {
            borderColor: '#828282',
          },
        }}
        endIcon={<ArrowOutwardIcon />} // Add the icon here
      >
        View Article
      </IconButton>
    </Box>
  );
};

export default SupportArticlesItem;
